/**
 * Set the public path dynamically since each CDN has its own domain.
 * https://webpack.js.org/guides/public-path/
 */
if (window._STATIC_JS_BUILD_PATH) {
  // We MUST write this like this, not as window.__webpack_public_path__, since this is a magical
  // code snippet transformed by webpack. That's also why we need to include it in a regular JS file
  // rather than server-rendering a script tag.
  // eslint-disable-next-line camelcase
  __webpack_public_path__ = window._STATIC_JS_BUILD_PATH;
}

// Explicitly export nothing to convince tools that this is a JS module, not a script.
export {};
